<template>
  <CollapsibleLinks>
    <template #trigger="{ toggle }">
      <a
        class="font-bold text-primary hover:text-primary-dark text-lg"
        @click.stop.prevent="toggle"
        >{{ $t("footer.forMates") }}</a
      >
    </template>
    <div class="flex flex-col mb-3 gap-1 text-sm">
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.REGISTRATION)"
        :to="localePath({ name: 'registrationPage' })"
        class="text-white"
      >
        {{ $t("footer.register") }}
      </FooterClickLink>
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.JOB_MARKET)"
        class="text-white"
        :to="localePath({ name: 'buyTendersPage' })"
      >
        {{ $t("footer.jobs") }}
      </FooterClickLink>
    </div>
  </CollapsibleLinks>
</template>

<script>
import CollapsibleLinks from "./CollapsibleLinks.vue";
import FooterClickLink from "./FooterClickLink.vue";
import { FEATURES } from "~/config/pages/features.config";

export default {
  components: { CollapsibleLinks, FooterClickLink },
  setup() {
    return {
      FEATURES,
    };
  },
};
</script>
